import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, startWith } from 'rxjs/operators';
import { UserService } from './user.service';

const COLORVARS = [
  '--graph-label-primary',
  '--graph-label-secondary',
  '--graph-line-theme',
  '--graph-grid-line-primary',
  '--graph-grid-line-secondary',
  '--graph-line-primary',
  '--graph-line-secondary',
  '--graph-line-tertiary',
  '--graph-line-quaternary',
  '--theme-color-primary-light'
];


@Injectable({
  providedIn: 'root'
})
export class ColorService {
  colors: { [key: string]: string; };
  colors$: Observable<{ [key: string]: string; }>;
  renderer: Renderer2;
  faviconLink: any;

  constructor(
    private userService: UserService,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.mapColorsOnThemeChanges();
  }

  private mapColorsOnThemeChanges() {
    this.colors$ = this.userService.userPreferences$.pipe(
      startWith(this.userService.userPreferences$.value),
      map(userPrefs => userPrefs.theme),
      distinctUntilChanged(),
      map(theme => {
        this.setFavicon(theme);
        this.renderer.setAttribute(document.body, 'data-theme', theme);
        this.colors = COLORVARS.reduce((colorVars, colorVar) => {
          colorVars[colorVar] = this.getComputedValue(colorVar);
          return colorVars;
        }, {} as { [key: string]: string; });
        return this.colors;
      }),
      shareReplay()
    );
  }

  setFavicon(theme: string) {
    if (!this.faviconLink) {
      this.faviconLink = this.renderer.createElement('link');
      this.renderer.setAttribute(this.faviconLink, 'rel', 'icon');
      this.renderer.setAttribute(this.faviconLink, 'type', 'image/x-icon');
      this.renderer.appendChild(document.head, this.faviconLink);
    }
    if (theme === 'light-theme') {
      this.renderer.setAttribute(this.faviconLink, 'href', 'assets/favicons/favicon-light.png');
    } else if (theme === 'dark-theme') {
      this.renderer.setAttribute(this.faviconLink, 'href', 'assets/favicons/favicon-dark.png');
    } else {
      this.renderer.setAttribute(this.faviconLink, 'href', 'assets/favicons/favicon.ico');
    }
  }

  /**
   * Get the color value from our CSS variables
   * @param cssVariable
   */
  getComputedValue(cssVariable: string): string {
    return window.getComputedStyle(document.body).getPropertyValue(cssVariable);
  }

}
